import React, { useState } from 'react'
import { Link } from 'react-router-dom'

export const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="nav">
      <div className="nav-row max-w-[1200px] mx-auto px-8">
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img 
            src="/logos/Jobloads+Logotype+Bright-08.png" 
            alt="Jobloads" 
            className="logo-img" 
            style={{ height: '30px', width: 'auto' }} 
          />
        </Link>
        
        <button 
          className={`nav-toggle ${isOpen ? 'is-active' : ''}`} 
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav-links ${isOpen ? 'is-open' : ''}`}>
          <Link to="/#crewloads" onClick={() => setIsOpen(false)}>Crewloads</Link>
          <Link to="/#story" onClick={() => setIsOpen(false)}>Our story</Link>
          <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
        </nav>
      </div>
    </div>
  )
}

